import { render } from "./ShipmentsInquiryContainer.vue?vue&type=template&id=14af47bd"
import script from "./ShipmentsInquiryContainer.vue?vue&type=script&lang=js"
export * from "./ShipmentsInquiryContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__